var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-image',{attrs:{"bucket":_vm.imageBucket,"file-name":_vm.imageFileName}})}
var staticRenderFns = []

export { render, staticRenderFns }